export class PrivateComponentNames {
    constructor(public stem: string) {
    }
    get selector() {
        return "nps-" + this.stem;
    }
}

export class Authorization {
    static module = "authorization";
    static ssoLogoutPath = "/connect/endsession";
    static ssoAuthorizePath = "/connect/authorize";
    static clientIdParam = "client_id";
    static redirectUriParam = "redirect_uri";
    static stateParam = "state";
    static scopeParam = "scope";
    static responseTypeParam = "response_type";
    static responseType = "id_token token";
    static responseTypeNoOpenId = "token";
    static ssoUnauthorizedPath = "/account/unauthorized";
    static nonceParam = "nonce";
}

export class Names {
    static authorization = Authorization;
    static dropdown = new PrivateComponentNames("dropdown");
    static spinner = new PrivateComponentNames("spinner");
    static environment = new PrivateComponentNames("environment");
    static applicationBar = new PrivateComponentNames("application-bar");
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/names.ts